import React, { useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import { Col, Row, Button } from 'reactstrap';
import AlertModal from '../../../../shared/components/Modal';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import moment from 'moment';

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },
    },
});

const ModalCalendarNotes = ({ dateCalendar, closeModal, opened, Callback }) => {

    const [openModal, setOpenModal] = useState(opened);
    const [showAlertModal, setAlerShowModal] = useState(false);
    const [messagAlerteModal, setAlertMessageModal] = useState(null);
    const [colorAlertModal, setAlertColorModal] = useState("");

    const [title, setTitle] = useState(null);
    const [note, setNote] = useState(null);

    useEffect(() => {

    }, []);

    const toggleModal = async (onOk) => {
        setAlerShowModal(false);
        setAlertMessageModal("");
        if (colorAlertModal == "success") {
            setAlertColorModal("");
            Callback();
            closeModal();
        }

        if (colorAlertModal == "warning") {
            setAlertColorModal("");
            if (onOk) {
                await saveNote();
            }
        }
    }

    const saveNote = async () => {
        let usuario = JSON.parse(sessionStorage.getItem('usuario'));
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'agenda-notas/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                titulo: title == null || title == undefined ? "" : title,
                nota: note,
                fecha_nota: moment(dateCalendar).format("YYYY-MM-DD"),
                id_usuario: usuario.id_usuario
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                setAlertMessageModal("Nota agregada correctamente");
                setAlertColorModal("success");
                setAlerShowModal(true);
            }
            else {
                throw new Error('Data');
            }
        }).catch(err => {
            console.log(err);
            setAlertMessageModal("Ha ocurrido un error en el servidor");
            setAlertColorModal("danger");
            setAlerShowModal(true);
        });
    }

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Agregar Nota</h5>
                        </div>
                    </div>

                    <Row>
                        <Col md={6}>
                            <MuiPickersUtilsProvider utils={MomentUtils} >
                                <ThemeProvider theme={defaultMaterialTheme}>
                                    <KeyboardDatePicker
                                        variant="inline"
                                        style={{ width: '100%', }}
                                        value={dateCalendar != null && dateCalendar != undefined ? dateCalendar : null}
                                        disabled={true}
                                        label="Fecha de la Nota"
                                        format="DD/MM/YYYY"
                                        animateYearScrolling
                                        className='medical-material-form__field material-form__label'
                                        InputLabelProps={{
                                            style: { color: '#646777' }
                                        }}
                                    />
                                </ThemeProvider>
                            </MuiPickersUtilsProvider>
                        </Col>
                        <Col md={6}>
                            <TextField
                                id="txtTitulo"
                                label="Titulo (Opcional)"
                                style={{ width: '100%', }}
                                type="text"
                                className="medical-material-form__field material-form__label"
                                value={title}
                                onChange={(e) => {
                                    setTitle(e.target.value);
                                }}
                                InputLabelProps={{
                                    style: { color: '#646777' }
                                }}
                            />
                        </Col>
                    </Row>


                    <div className="form" style={{ display: "flex", flexDirection: "column" }}>
                        <div className="form__form-group">
                            <span className="form__form-group-label">Nota</span>
                            <div className="form__form-group-field">
                                <textarea
                                    maxLength={255}
                                    name="textarea-note"
                                    defaultValue={note}
                                    value={note}
                                    onChange={(e) => {
                                        setNote(e.target.value);
                                    }}
                                >
                                </textarea>
                            </div>
                        </div>
                    </div>


                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                setAlertMessageModal("Esta seguro de crear esta nota?");
                                setAlertColorModal("warning");
                                setAlerShowModal(true);
                            }}
                        >
                            Crear
                        </Button>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => toggleModal(true)}
                toggle={() => toggleModal(false)}
            />

        </div>
    );
};
export default ModalCalendarNotes;
